import React from 'react';
import { useTranslation } from 'react-i18next';

const statusClasses = {
  'New': 'badge-new',
  'Contacted': 'badge-contacted',
  'Follow-up': 'badge-followup',
  'Meeting Scheduled': 'badge-meeting',
  'Qualified': 'badge-qualified',
  'Converted': 'badge-converted',
  'Not Interested': 'badge-not-interested',
  'Closed': 'badge-closed',
  'New Student': 'badge-new-student',
  'Application Submitted': 'badge-app-submitted',
  'Offer Letter Received': 'badge-offer-received',
  'Offer Accepted': 'badge-offer-accepted',
  'Offer Rejected': 'badge-offer-rejected',
  'Visa Applied': 'badge-visa-applied',
  'Visa Approved': 'badge-visa-approved',
  'Visa Rejected': 'badge-visa-rejected',
  'Enrolled': 'badge-enrolled',
  'Withdrawn': 'badge-withdrawn',
  'Deferred': 'badge-deferred',
  'B2C': 'badge-b2c',
  'B2B': 'badge-b2b',
  'B2B-S': 'badge-b2b-s',
};

const StatusBadge = ({ status }) => {
  const { t } = useTranslation();

  const getStatusLabel = (status) => {
    const key = {
      'New': 'statusBadge.new',
      'Contacted': 'statusBadge.contacted',
      'Follow-up': 'statusBadge.followUp',
      'Meeting Scheduled': 'statusBadge.meetingScheduled',
      'Qualified': 'statusBadge.qualified',
      'Converted': 'statusBadge.converted',
      'Not Interested': 'statusBadge.notInterested',
      'Closed': 'statusBadge.closed',
      'New Student': 'statusBadge.newStudent',
      'Application Submitted': 'statusBadge.applicationSubmitted',
      'Offer Letter Received': 'statusBadge.offerLetterReceived',
      'Offer Accepted': 'statusBadge.offerAccepted',
      'Offer Rejected': 'statusBadge.offerRejected',
      'Visa Applied': 'statusBadge.visaApplied',
      'Visa Approved': 'statusBadge.visaApproved',
      'Visa Rejected': 'statusBadge.visaRejected',
      'Enrolled': 'statusBadge.enrolled',
      'Withdrawn': 'statusBadge.withdrawn',
      'Deferred': 'statusBadge.deferred',
    }[status];
    return key ? t(key) : status;
  };

  const className = statusClasses[status] || 'badge-new';
  return <span className={`badge ${className}`}>{getStatusLabel(status)}</span>;
};

export default StatusBadge;
